import { render } from "./besoinsVue.vue?vue&type=template&id=56352eca"
import script from "./besoinsVue.vue?vue&type=script&lang=js"
export * from "./besoinsVue.vue?vue&type=script&lang=js"

import "./besoinsVue.vue?vue&type=style&index=0&id=56352eca&lang=css"
import "../assets/css/besoin.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__